import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';

var EmptyContent = /*#__PURE__*/function (_Vue) {
  _inherits(EmptyContent, _Vue);

  var _super = _createSuper(EmptyContent);

  function EmptyContent() {
    _classCallCheck(this, EmptyContent);

    return _super.apply(this, arguments);
  }

  return EmptyContent;
}(Vue);

EmptyContent = __decorate([Component], EmptyContent);
export default EmptyContent;